module.exports = __webpack_public_path__ + "img/etc-etc-checkbox-dn.089ca9ff.svg";